/// <reference path="../../typings/browser.d.ts" />

// tslint:disable:no-bitwise

namespace Application.Common {
   'use strict';

    export class IpUtils {
        public static checkIpAgainstSubnetAndMask(ip: string, subnet: string, mask: string | number): boolean {
            if (typeof mask === 'number') {
                return (ipConverter(ip) & cidrConverter(mask)) === ipConverter(subnet);
            } else if (typeof mask === 'string') {
                return (ipConverter(ip) & ipConverter(mask)) === ipConverter(subnet);
            }
        }

        /**
         * Method to check if the ip entered in a multicast IP
         * @param ip the string to be checked
         * @return true if multicast ip false otherwise
         */
        public static ipIsMulticast(ip: string): boolean {
            let ipformat = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
            if(ip.match(ipformat)){
                let min: number = IPToNumber("224.0.0.0");
                let max: number = IPToNumber("239.255.255.255");
                let ipNumber: number = IPToNumber( ip );
                return ipNumber > min && ipNumber < max;
            }
            return false;
        }
    }

    function ipConverter(ip: string): number {
        let regIp: RegExpMatchArray = ip.match(/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/);
        if (regIp) {
            return (+regIp[1] << 24) + (+regIp[2] << 16) + (+regIp[3] << 8) + (+regIp[4]);
        }
        return undefined;
    }

    function cidrConverter(mask: number): number {
        return -1 << (32 - mask);
    }

    function IPToNumber(s: string): number {
        let arr: Array<string> = s.split(".");
        let n: number = 0;
        for (let i: number = 0; i < 4; i++) {
            n = n * 256;
            n += parseInt(arr[i], 10);
        }
        return n;
    }
}